
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The unit of measure from the UN/CEFACT Unit Codes for Trade (2014, Annex II & Annex III).`}</p>
    <p>{`Currently, this will always be "WEE", representing "week".`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;